/**
 * @generated SignedSource<<e30149e613a64a746917bd3e57448c68>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ChatBubbleTypeEnum = "CAROUSEL_COMMERCE" | "CAROUSEL_FEED" | "COMMERCE" | "IMAGE" | "PREMIUM_VIDEO" | "TEXT" | "WIDE" | "WIDE_ITEM_LIST" | "%future added value";
export type BrandMessageTemplateId_brandMessageTemplateQuery$variables = {
  id: string;
};
export type BrandMessageTemplateId_brandMessageTemplateQuery$data = {
  readonly brandMessageTemplate: {
    readonly buttons: ReadonlyArray<{
      readonly linkAndroid: string | null;
      readonly linkIos: string | null;
      readonly linkMobile: string | null;
      readonly linkPc: string | null;
      readonly linkType: string;
      readonly name: string;
    }>;
    readonly chatBubbleType: ChatBubbleTypeEnum;
    readonly content: string;
    readonly coupon: {
      readonly description: string;
      readonly linkAndroid: string | null;
      readonly linkIos: string | null;
      readonly linkMobile: string | null;
      readonly linkPc: string | null;
      readonly title: string;
    } | null;
    readonly id: string;
    readonly image: {
      readonly key: string;
      readonly size: number;
    } | null;
    readonly imageLink: string | null;
    readonly templateName: string;
    readonly " $fragmentSpreads": FragmentRefs<"BrandMessageTaskCreateDialog_brandMessageTemplate" | "BrandMessageTemplateDescriptionList_brandMessageTemplate" | "BrandMessageTemplateUpdateDialog_brandMessageTemplate">;
  };
};
export type BrandMessageTemplateId_brandMessageTemplateQuery = {
  response: BrandMessageTemplateId_brandMessageTemplateQuery$data;
  variables: BrandMessageTemplateId_brandMessageTemplateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "templateName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "chatBubbleType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "size",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageLink",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkType",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkIos",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkMobile",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkPc",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkAndroid",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandMessageTemplateId_brandMessageTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandMessageTemplate",
        "kind": "LinkedField",
        "name": "brandMessageTemplate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BrandMessageTemplateDescriptionList_brandMessageTemplate"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BrandMessageTemplateUpdateDialog_brandMessageTemplate"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BrandMessageTaskCreateDialog_brandMessageTemplate"
          },
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandMessageButton",
            "kind": "LinkedField",
            "name": "buttons",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandMessageCoupon",
            "kind": "LinkedField",
            "name": "coupon",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v14/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v16/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandMessageTemplateId_brandMessageTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandMessageTemplate",
        "kind": "LinkedField",
        "name": "brandMessageTemplate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "serviceStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updateTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "templateCode",
            "storageKey": null
          },
          (v3/*: any*/),
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "parameterNames",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "adult",
            "storageKey": null
          },
          (v8/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "imageUrl",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "header",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "additionalContent",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "carousel",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "wideItemList",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "video",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "commerce",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandMessageButton",
            "kind": "LinkedField",
            "name": "buttons",
            "plural": true,
            "selections": [
              (v9/*: any*/),
              (v12/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bizFormId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ordering",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BrandMessageCoupon",
            "kind": "LinkedField",
            "name": "coupon",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v15/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "image",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "822767173a079d00716e515a3b5c404c",
    "id": null,
    "metadata": {},
    "name": "BrandMessageTemplateId_brandMessageTemplateQuery",
    "operationKind": "query",
    "text": "query BrandMessageTemplateId_brandMessageTemplateQuery(\n  $id: ID!\n) {\n  brandMessageTemplate(id: $id) {\n    id\n    ...BrandMessageTemplateDescriptionList_brandMessageTemplate\n    ...BrandMessageTemplateUpdateDialog_brandMessageTemplate\n    ...BrandMessageTaskCreateDialog_brandMessageTemplate\n    templateName\n    content\n    chatBubbleType\n    image {\n      key\n      size\n      id\n    }\n    imageLink\n    buttons {\n      name\n      linkType\n      linkIos\n      linkMobile\n      linkPc\n      linkAndroid\n    }\n    coupon {\n      description\n      linkAndroid\n      linkIos\n      linkMobile\n      linkPc\n      title\n    }\n  }\n}\n\nfragment BrandMessageTaskCreateDialog_brandMessageTemplate on BrandMessageTemplate {\n  id\n  content\n  parameterNames\n}\n\nfragment BrandMessageTemplateDescriptionList_brandMessageTemplate on BrandMessageTemplate {\n  id\n  createTime\n  serviceStatus\n  updateTime\n  templateCode\n  templateName\n  chatBubbleType\n  parameterNames\n  adult\n  imageLink\n  imageUrl\n  content\n  header\n  additionalContent\n  carousel\n  wideItemList\n  video\n  commerce\n  buttons {\n    name\n    linkMobile\n    linkType\n    linkIos\n  }\n  coupon {\n    title\n    description\n    linkMobile\n    linkPc\n    linkAndroid\n    linkIos\n  }\n}\n\nfragment BrandMessageTemplateUpdateDialog_brandMessageTemplate on BrandMessageTemplate {\n  templateCode\n  templateName\n  chatBubbleType\n  content\n  adult\n  imageUrl\n  imageLink\n  header\n  additionalContent\n  carousel\n  wideItemList\n  video\n  commerce\n  buttons {\n    name\n    linkType\n    linkIos\n    linkMobile\n    linkPc\n    linkAndroid\n    bizFormId\n    ordering\n  }\n  coupon {\n    description\n    linkAndroid\n    linkIos\n    linkMobile\n    linkPc\n    title\n  }\n}\n"
  }
};
})();

(node as any).hash = "a6530604829ad1845b565be8cbcb06a6";

export default node;
